export const cloneDocument = value => JSON.parse(JSON.stringify(value));
export const documentSignature = value => JSON.stringify(value || null);
// Reality state saved in a revision. Cameras, environment and selection are
// view state: they never make the scene "unsaved" or create a revision.
export const realitySignature = value => {
  if (!value) return 'null';
  const { camera, earthCamera, environment, selection, ...reality } = value;
  return JSON.stringify(reality);
};

export function editSpatialNode(document, id, change) {
  return { ...document, nodes: document.nodes.map(node => node.id === id ? { ...node, ...change } : node) };
}
export function duplicateSpatialNode(document, id, nextId) {
  const node = document.nodes.find(row => row.id === id);
  if (!node || document.nodes.length >= 100) return document;
  if (!nextId) { const ids = new Set(document.nodes.map(row => row.id)); let sequence = 1; while (ids.has(`instance-${sequence}`)) sequence += 1; nextId = `instance-${sequence}`; }
  const copy = { ...cloneDocument(node), id: nextId, name: `${node.name.slice(0, 95)} copy`, position: [node.position[0] + .25, node.position[1], node.position[2]] };
  return { ...document, nodes: [...document.nodes, copy], selection: nextId };
}
export function deleteSpatialNode(document, id) {
  const nodes = document.nodes.filter(node => node.id !== id);
  return { ...document, nodes, selection: document.selection === id ? nodes[0]?.id || null : document.selection };
}
export function resetSpatialNode(document, id) { return editSpatialNode(document, id, { position: [0, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1] }); }
